const PatientNameCell = (props: any) => {

  return (
    <div className='d-flex ms-5'>
      <div className='d-flex flex-row col align-items-center '>
        <span className='text-black fw-bold fs-7 '>
          {props?.tableProps?.patientName} 
        </span>

      </div>
    </div>
  )
}

export {PatientNameCell}
